import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from 'material-ui/CircularProgress';
import OverlayController from '../../overlay/OverlayController';
import userContext from "../../../services/userContext";
import utils from "../../../utils/utils";
import config from '../../../config';
import './PluginItemView.css';


export default class PluginItemView extends React.Component {

    static propTypes = {
        projectId: PropTypes.string.isRequired,
        item: PropTypes.object.isRequired,
        configuration: PropTypes.object,
        updateItem: PropTypes.func.isRequired,
        reportEvent: PropTypes.func.isRequired,
        refreshQueues: PropTypes.func.isRequired
    };

    static defaultProps = {
        configuration: null
    };

    constructor(props) {
        super(props);

        this.onMessageHandler = this.onMessageHandler.bind(this);
        this.iframeElm = null;
        this.state = {
            isIFrameLoading: true
        };
    }

    onIFrameLoad() {
        this.setState({isIFrameLoading: false});
    }

    getIframeUrl() {
        let url = this.props.configuration.iframeUrl;
        url += url.indexOf('?') === -1 ? '?' : '&';
        url += "projectId=" + this.props.projectId;
        url += "&itemId=" + this.props.item.id;
        if (this.props.item.clientId) {
            url += "&clientId=" + encodeURIComponent(this.props.item.clientId);
        }
        if (config.env !== "prod") {
            url += "&env=" + config.env;
        }
        return url;
    }

    componentDidMount() {
        window.addEventListener("message", this.onMessageHandler, false);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.onMessageHandler, false);
    }

    onMessageHandler(event) {
        let action = event.data.action;
        let callbackId = event.data.callbackId;
        let source = event.source;
        let origin = event.origin;
        if (source !== this.iframeElm.contentWindow) {
            return;
        }
        switch (action) {
            case "getCurrentUser":
                let user = userContext.getCurrentUser();
                source.postMessage({
                    action: "response",
                    result: user ? utils.defaultOptions({id: null, email: null, name: null}, user) : null,
                    callbackId: callbackId
                }, origin);
                break;
            case "getItem":
                source.postMessage({
                    action: "response",
                    result: this.props.item,
                    callbackId: callbackId
                }, origin);
                break;
            case "updateItem":
                this.props.updateItem(event.data.updateItemData)
                    .then((result) => {
                        source.postMessage({
                            action: "response",
                            result: result,
                            callbackId: callbackId
                        }, origin);
                    })
                    .catch((error) => {
                        OverlayController.showErrorAlert(error);
                        source.postMessage({
                            action: "response",
                            error: error,
                            callbackId: callbackId
                        }, origin);
                    });
                break;
            case "reportEvent":
                OverlayController.showActivityIndicator();
                this.props.reportEvent(event.data.eventName)
                    .then(() => {
                        OverlayController.hideActivityIndicator();
                    })
                    .catch((error) => {
                        OverlayController.hideActivityIndicator();
                        OverlayController.showErrorAlert(error);
                        source.postMessage({
                            action: "response",
                            error: error,
                            callbackId: callbackId
                        }, origin);
                    });
                break;
            case "refreshQueues":
                OverlayController.showActivityIndicator();
                this.props.refreshQueues()
                    .then(() => {
                        OverlayController.hideActivityIndicator();
                        OverlayController.hideOverlay();
                    })
                    .catch((error) => {
                        OverlayController.hideActivityIndicator();
                        OverlayController.showErrorAlert(error);
                        source.postMessage({
                            action: "response",
                            error: error,
                            callbackId: callbackId
                        }, origin);
                    });
                break;
            default:
                break;
        }
    }

    render() {
        let className = 'pluginItemViewIframe';
        if (this.state.isIFrameLoading) {
            className += ' loading';
        }
        return (
            <div className="pluginItemViewIframeContainer">
                {this.state.isIFrameLoading && <CircularProgress className="activityIndicator"/>}
                <iframe src={this.getIframeUrl()} className={className} onLoad={() => this.onIFrameLoad()} ref={(elm) => { this.iframeElm = elm; }}/>
            </div>
        )
    }

};



// WEBPACK FOOTER //
// ./src/components/plugins/iframePlugin/PluginItemView.js